<div class="card ">
  <div class="card-header" style="border-bottom: none;">
    <div class="card-title d-flex flex-column">
      <h4>{{ data.title }}</h4>
    </div>
  </div>
  <div class="card-body">
    <div id="{{ data.widgetId }}" style="height: 550px;"></div>
  </div>
</div>
